module.exports = __webpack_public_path__ + "img/parler-1.539ca277.png";